import React from 'react';
import CalendarOutlined from '@ant-design/icons/CalendarOutlined';
import ClockCircleOutlined from '@ant-design/icons/ClockCircleOutlined';
import { TIME } from './constant';
const useSuffix = ({ picker, hasFeedback, feedbackIcon, suffix }) => {
    if (suffix === null || suffix === false) {
        return null;
    }
    if (suffix === true || suffix === undefined) {
        return (React.createElement(React.Fragment, null,
            picker === TIME ? (React.createElement(ClockCircleOutlined, { "aria-hidden": "true" })) : (React.createElement(CalendarOutlined, { "aria-hidden": "true" })),
            hasFeedback && feedbackIcon));
    }
    return suffix;
};
export default useSuffix;
